document.documentElement.classList.remove('no-js');

document.addEventListener('click',function(e){
  const t=e.target.closest('[data-menu-toggle]');
  if(t){
    const nav=document.querySelector('[data-mobile-nav]');
    const open=nav?.classList.toggle('is-open') || false;
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    t.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  }
});

document.addEventListener('keydown',function(e){
  if(e.key!=='Escape')return;
  const nav=document.querySelector('[data-mobile-nav]');
  const btn=document.querySelector('[data-menu-toggle]');
  if(nav?.classList.contains('is-open')){
    nav.classList.remove('is-open');
    btn?.setAttribute('aria-expanded','false');
    btn?.setAttribute('aria-label','Open menu');
    btn?.focus();
  }
});

document.addEventListener('submit',function(e){
  const form=e.target.closest('.product-form');
  if(!form)return;
  const btn=form.querySelector('button[type="submit"]');
  if(btn){
    btn.dataset.label=btn.textContent;
    btn.textContent='Adding…';
    setTimeout(()=>btn.textContent=btn.dataset.label||'Add to cart',1600);
  }
});

document.addEventListener('DOMContentLoaded',function(){
  const params=new URLSearchParams(window.location.search);
  const product=params.get('product');
  if(!product)return;
  const human=product.replace(/-/g,' ').replace(/\b\w/g,c=>c.toUpperCase());
  document.querySelectorAll('[data-product-prefill]').forEach(el=>{
    if(!el.value)el.value=human;
    const note=document.createElement('div');
    note.className='prefill-product-note';
    note.textContent='Product selected from website: '+human;
    el.closest('.field')?.insertAdjacentElement('beforebegin',note);
  });
  document.querySelectorAll('[data-product-prefill-hidden]').forEach(el=>{el.value=human;});
});